// extracted by mini-css-extract-plugin
module.exports = {"icon":"ob_vNFyLx","hover":"ob_PM1JlF","hoverIcon":"ob_PoPGaN","baseIcon":"ob_0c9hD0","active":"ob_P3kgEw","activeIcon":"ob_7kFihJ","clickable":"ob_hxozSb"};